var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-spin",
    { attrs: { size: "large", spinning: _vm.loading } },
    [
      _c("common-layout", [
        _c("div", { staticClass: "main-login" }, [
          !_vm.isMobile
            ? _c("div", { staticClass: "left" }, [
                _c("div", { staticClass: "left-wrap" }, [
                  _c(
                    "div",
                    { staticClass: "header" },
                    [
                      _c("svg-icon", {
                        staticClass: "logo",
                        staticStyle: {
                          width: "309px",
                          height: "44px",
                          background: "none",
                        },
                        attrs: { iconClass: "login" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "left-img" },
                    [
                      _c(
                        "a-carousel",
                        { attrs: { autoplay: "", dotsClass: "dots" } },
                        [
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/login1.png"),
                              },
                            }),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/login2.png"),
                              },
                            }),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/login3.png"),
                              },
                            }),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/login4.png"),
                              },
                            }),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/login5.png"),
                              },
                            }),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/login6.png"),
                              },
                            }),
                          ]),
                          _c("div", [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/img/login7.png"),
                              },
                            }),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "right" }, [
            _c("div", { staticClass: "login" }, [
              _c("div", { staticClass: "title", class: [_vm.lang] }, [
                _vm._v(
                  " " +
                    _vm._s(
                      !_vm.sendStatus
                        ? _vm.$t("PasswordReset")
                        : _vm.$t("Success")
                    ) +
                    " "
                ),
              ]),
              _c("div", { staticClass: "subTitle", class: [_vm.lang] }, [
                _vm._v(
                  " " +
                    _vm._s(
                      !_vm.sendStatus
                        ? _vm.$t("resetPwdDes")
                        : _vm.$t("haveSentEmail")
                    ) +
                    " "
                ),
              ]),
              !_vm.sendStatus
                ? _c(
                    "div",
                    { staticClass: "wrapForm" },
                    [
                      _c(
                        "a-form",
                        {
                          attrs: {
                            layout: "vertical",
                            form: _vm.form,
                            size: "large",
                          },
                        },
                        [
                          _c("div", { staticClass: "form-label" }, [
                            _vm._v(_vm._s(_vm.$t("Email"))),
                          ]),
                          _c(
                            "a-form-item",
                            {
                              class: [_vm.lang],
                              attrs: {
                                "validate-status": _vm.userNameError()
                                  ? "error"
                                  : "",
                                help: _vm.userNameError() || "",
                              },
                            },
                            [
                              _c(
                                "a-input",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "userName",
                                        {
                                          trigger: "blur",
                                          rules: [
                                            {
                                              required: true,
                                              validator: function (
                                                rule,
                                                value,
                                                callback
                                              ) {
                                                let reg =
                                                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                                if (
                                                  !value ||
                                                  !value.trim("") ||
                                                  !reg.test(value)
                                                ) {
                                                  // callback($t('rightAccount'));
                                                  callback(_vm.$t("rightEmail"))
                                                  return
                                                }
                                                callback()
                                              },
                                            },
                                          ],
                                        },
                                      ],
                                      expression:
                                        "[\n                    'userName',\n                    {\n                      trigger: 'blur',\n                      rules: [\n                        {\n                          required: true,\n                          validator: function (rule, value, callback) {\n                            let reg =\n                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$/;\n                            if (\n                              !value ||\n                              !value.trim('') ||\n                              !reg.test(value)\n                            ) {\n                              // callback($t('rightAccount'));\n                              callback($t('rightEmail'));\n                              return;\n                            }\n                            callback();\n                          },\n                        },\n                      ],\n                    },\n                  ]",
                                    },
                                  ],
                                  attrs: { placeholder: _vm.$t("Email") },
                                },
                                [
                                  _c("a-icon", {
                                    staticStyle: {
                                      color: "rgba(0, 0, 0, 0.25)",
                                    },
                                    attrs: { slot: "prefix", type: "mail" },
                                    slot: "prefix",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            [
                              _c(
                                "a-button",
                                {
                                  staticStyle: { width: "60%" },
                                  attrs: {
                                    type: "primary",
                                    "html-type": "submit",
                                    disabled:
                                      _vm.hasErrors(
                                        _vm.form.getFieldsError()
                                      ) || !_vm.haveFormValue()
                                        ? true
                                        : false,
                                  },
                                  on: { click: _vm.onSubmit },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("ResetInstructions")) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "ReturntoLogIn", class: [_vm.lang] }, [
                _c("span", { on: { click: _vm.toLogin } }, [
                  _vm._v(" " + _vm._s(_vm.$t("ReturntoLogIn")) + " "),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }